<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'LaporanNonKeuangan',

    metaInfo: { title: 'Laporan Non Keuangan' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'non-financial-report',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'nonfinancialreport',
      },
    },
  }
</script>
